import script from "./ResourceTransChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceTransChat.vue?vue&type=script&setup=true&lang=ts"

import "./ResourceTransChat.vue?vue&type=style&index=0&id=7c771131&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c771131"]])

export default __exports__